import React from 'react';

import { RoundedPanel } from '~/components/AiChat/SideBarDialog/components/RoundedPanel/RoundedPanel';
import { replaceDatesWithLocaleString } from '~/components/AiChat/SideBarDialog/utils';
import type { ActionTaskData, AiAction } from '~/components/AiChat/types';
import { MarkdownSection } from '~/components/core/MarkdownSection';

interface ActionsPanelProps {
  action: AiAction;
}

export const AssessDamageActionInner: React.FC<ActionsPanelProps> = ({ action }) => {
  const { explanation, additional_actions = '' } = action.task_data as ActionTaskData;

  return (
    <RoundedPanel variant="clear">
      <MarkdownSection markdown={replaceDatesWithLocaleString(explanation)} />
      <MarkdownSection markdown={replaceDatesWithLocaleString(additional_actions)} />
    </RoundedPanel>
  );
};
